import api from 'core/util/api';
import { AssetTag } from '@kentik/ui-shared/dictionary/types';
import { UseQueryOptions } from '@tanstack/react-query';

const queryFn = () => api.get('/api/ui/dictionary/deviceTags') as Promise<AssetTag[]>;

export const assetTagsQuery = {
  queryKey: ['assetTagsRaw'] as const,
  queryFn,
  staleTime: 300000
} as const satisfies UseQueryOptions<AssetTag[], Error, AssetTag[], readonly ['assetTagsRaw']>;
